<template>
    <b-container>
        <b-row>
            <b-col xs="12">
                <b-form-textarea
                    v-model="notification.message"
                    placeholder="Mensaje"
                    :rows="5"
                    :max-rows="5">
                </b-form-textarea>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col xs="6">
                <multiselect
                    id="parent"
                    v-model="notification.headquarters"
                    :options="headquarters"
                    track-by="uuid"
                    label="name"
                    :multiple="false"
                    :allowEmpty="true"
                    placeholder="Sede"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""></multiselect>
            </b-col>

            <b-col xs="6">
                <multiselect
                    v-model="notification.department"
                    :options="visibleDepartments"
                    track-by="uuid"
                    label="description"
                    :multiple="false"
                    :allowEmpty="true"
                    placeholder="Departamento"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""></multiselect>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col xs="12">
                <multiselect
                    v-model="notification.users"
                    :options="visibleUsers"
                    track-by="uuid"
                    label="username"
                    :multiple="true"
                    :allowEmpty="true"
                    placeholder="Usuario"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""></multiselect>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col xs="12" class="d-flex flex-row-reverse">
                <button
                    v-if="renderSaveButton"
                    class="btn btn-brand btn-primary btn-lg"
                    @click="submitNotification">
                    <slot></slot>
                </button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "user-notification-form",
        components: {
            Multiselect
        },
        props: [
            'headquarters',
            'users',
            'initialNotification',
            'renderSaveButton'
        ],
        data: function () {
            return {
                notification: {
                    message: this.initialNotification.message,
                    headquarters: this.initialNotification.headquarters,
                    department: this.initialNotification.department,
                    users: this.initialNotification.users
                }
            };
        },
        computed: {
            visibleDepartments() {
                if (!!this.notification.headquarters && !!this.notification.headquarters.departments) {
                    return this.notification.headquarters.departments;
                } else {
                    return [];
                }
            },
            visibleUsers() {
                if (
                    !!this.notification.headquarters
                    && !!this.notification.headquarters.uuid
                    && !!this.notification.department
                    && !!this.notification.department.uuid
                ) {
                    return this.users.filter(
                        user => (
                            !!user.department
                            && user.department.uuid === this.notification.department.uuid
                            && !!user.headquarters
                            && user.headquarters.find(headquarters => (this.notification.headquarters.uuid === headquarters.uuid))
                        )
                    );
                } else if (!!this.notification.headquarters && !!this.notification.headquarters.uuid) {
                    return this.users.filter(
                        user => (
                            !!user.headquarters
                            && user.headquarters.find(headquarters => (this.notification.headquarters.uuid === headquarters.uuid))
                        )
                    );
                } else {
                    return this.users;
                }
            }
        },
        methods: {
            submitNotification() {
                if (this.renderSaveButton) {
                    this.$emit('submit-notification', this.notification);
                }
            }
        },
        watch: {
            'notification.headquarters': function (val) {
                this.notification.department = null;
            }
        }
    }
</script>

<style scoped>

</style>